import type {
  Answer,
  ChunkCitation,
  UIThreadMessagesItem,
} from "../../generated/core-api";

/** Extract chunk-level citations from an assistant answer in a thread. */
export function extractAnswerCitations(
  messages: UIThreadMessagesItem[],
  assistantMessageIndex: number,
): ChunkCitation[] {
  const message = messages[assistantMessageIndex];
  if (!message || message.role !== "assistant") {
    return [];
  }

  const response = message.content.response;
  if (!("citations" in response)) {
    return [];
  }

  return (response as Answer).citations ?? [];
}
